import { DataBean } from "../DataBean";

export class SalesConsultant extends DataBean {



    public async deleteSalesConsultant(idSalesConsultant: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSalesConsultant_Number", [idSalesConsultant]);
    }
    public async addSalesConsultant(idAccount: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesConsultant_addSalesConsultant_Number", [idAccount]);
    }
    public async getSalesConsultantCatalog(idAccount: any, idLnFunctionalID: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getSalesConsultantCatalog_Number_Number_String_Number_Number", [idAccount, idLnFunctionalID, regexStr, page, recordsPerPage]);
    }

}